import { Button } from '../common/Button';
import { GlassPanel } from '../common/GlassPanel';
import type { HeadsetDevice } from '../../types/device';

interface PairedDevicesProps {
  devices: HeadsetDevice[];
  onUnpair: (deviceId: string) => void;
  isBusy: boolean;
}

/**
 * List of currently paired headset devices for the /pair page.
 */
export function PairedDevices({ devices, onUnpair, isBusy }: PairedDevicesProps) {
  if (devices.length === 0) {
    return null;
  }

  return (
    <GlassPanel variant="soft" className="space-y-3">
      <h2 className="text-sm font-semibold text-white">Paired Devices</h2>
      {devices.map((device) => (
        <div
          key={device.deviceId}
          className="flex items-center justify-between rounded-xl border border-white/10 px-4 py-3"
        >
          <div>
            <div className="text-white font-medium">{device.deviceName}</div>
            <div className="text-xs text-ink-200">
              Paired {device.pairedAt.toLocaleDateString()}
            </div>
          </div>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => onUnpair(device.deviceId)}
            disabled={isBusy}
          >
            Unpair
          </Button>
        </div>
      ))}
    </GlassPanel>
  );
}
